
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ViewOffIconComponent } from "./view-off-icon.svg";

export const ViewOffIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ViewOffIconComponent {...props} />;
};
